import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Fade,
  useTheme,
  Paper,
  Grid
} from "@mui/material";
import useSetup from "../hooks/useSetup"; 

const EtapaEmpresa = ({
  company = {},
  setCompany = () => {},
  linkDigitado = "",
  setLinkDigitado = () => {}
}) => {
  const theme = useTheme();

  const [stepInterno, setStepInterno] = useState(company.companyName?1:0); // 0 = input site, 1 = sugestões
  const [loadingSugestao, setLoadingSugestao] = useState(false);

  const [companyName, setCompanyName] = useState(company.companyName || "");
  const [companyAbout, setCompanyAbout] = useState(company.companyAbout || "");
  const [companyWebsite, setCompanyWebsite] = useState(company.companyWebsite || "");
  const [segmento, setSegmento] = useState(company.segmento || "");
  const [publicoAlvo, setPublicoAlvo] = useState(company.publicoAlvo || "");
  const [focoPrincipal, setFocoPrincipal] = useState(company.focoPrincipal || "");
  const [maturidadeDigital, setMaturidadeDigital] = useState(company.maturidadeDigital || "");
  const [capacidadeEstrategica, setCapacidadeEstrategica] = useState(company.capacidadeEstrategica || "");

  const { generateSuggestions } = useSetup();

  const gerarSugestoes = async () => {
    setLoadingSugestao(true);
    try {
      const data = await generateSuggestions(linkDigitado); // Chama a API para gerar as sugestões
      setCompanyName(data.companyName);
      setCompanyAbout(data.companyAbout);
      setCompanyWebsite(data.companyWebsite);
      setSegmento(data.segmento);
      setPublicoAlvo(data.publicoAlvo);
      setFocoPrincipal(data.focoPrincipal);
      setMaturidadeDigital(data.maturidadeDigital);
      setCapacidadeEstrategica(data.capacidadeEstrategica);
      setStepInterno(1); // Passa para o passo de revisão das sugestões
      setCompany(data)
    } catch (error) {
      console.error("Erro ao gerar sugestões:", error);
    } finally {
      setLoadingSugestao(false);
    }
  };

  const renderFormularioEmpresa = () => (
    <>
      <Typography variant="body1" gutterBottom>
        Revise e edite as informações abaixo:
      </Typography>

      <Paper sx={{ p: 3, mt: 3 }} elevation={3}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Nome da Empresa"
              value={companyName}
              onChange={(e) => {
                const value = e.target.value;
                setCompanyName(value);
                setCompany((prev) => ({ ...prev, companyName: value }));
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Website"
              value={companyWebsite}
              onChange={(e) => {
                const value = e.target.value;
                setCompanyWebsite(value);
                setCompany((prev) => ({ ...prev, companyWebsite: value }));
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Sobre a empresa"
              value={companyAbout}
              onChange={(e) => {
                const value = e.target.value;
                setCompanyAbout(value);
                setCompany((prev) => ({ ...prev, companyAbout: value }));
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Segmento"
              value={segmento}
              onChange={(e) => {
                const value = e.target.value;
                setSegmento(value);
                setCompany((prev) => ({ ...prev, segmento: value }));
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Público-Alvo"
              value={publicoAlvo}
              onChange={(e) => {
                const value = e.target.value;
                setPublicoAlvo(value);
                setCompany((prev) => ({ ...prev, publicoAlvo: value }));
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Foco Principal"
              value={focoPrincipal}
              onChange={(e) => {
                const value = e.target.value;
                setFocoPrincipal(value);
                setCompany((prev) => ({ ...prev, focoPrincipal: value }));
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Maturidade Digital"
              value={maturidadeDigital}
              onChange={(e) => {
                const value = e.target.value;
                setMaturidadeDigital(value);
                setCompany((prev) => ({ ...prev, maturidadeDigital: value }));
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Capacidade Estratégica"
              value={capacidadeEstrategica}
              onChange={(e) => {
                const value = e.target.value;
                setCapacidadeEstrategica(value);
                setCompany((prev) => ({ ...prev, capacidadeEstrategica: value }));
              }}
            />
          </Grid>
        </Grid>

        <Box mt={3} display="flex" gap={2}>
          {stepInterno !== 0 && (
            <Button variant="text" onClick={() => setStepInterno(0)}>
              🔙 Voltar e informar outro site
            </Button>
          )}
        </Box>
      </Paper>

      <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: "block" }}>
        💡 Essas informações serão usadas para personalizar a experiência do cliente com sugestões automáticas de conteúdo, bot e automações.
      </Typography>
    </>
  );

  return (
    <Fade in>
      <Box sx={{ width: "100%"}}>
        <Typography variant="h4" fontWeight="bold" gutterBottom sx={{ color: theme.palette.primary.main }}>
          🎯 Informações da Empresa
        </Typography>

        {stepInterno === 0 && (
          <>
            <Typography variant="body1" gutterBottom>
              Para começarmos, informe o <strong>site</strong> ou  <strong>nome</strong> (caso não possua site) da sua empresa. Ou clique na opção preencher manualmente.
            </Typography>
            <TextField
              fullWidth
              label="Site ou nome da empresa"
              value={linkDigitado}
              onChange={(e) => setLinkDigitado(e.target.value)}
              placeholder="https://www.suaempresa.com.br ou nome da empresa"
              sx={{ mt: 2, mb: 3 }}
            />
            <Box display="flex" gap={2}>
              <Button
                variant="contained"
                disabled={!linkDigitado || loadingSugestao}
                onClick={gerarSugestoes}
              >
                {loadingSugestao ? <CircularProgress size={24} /> : "Gerar sugestões com IA"}
              </Button>
              <Button variant="text" onClick={() => setStepInterno(2)}>
                Preencher manualmente
              </Button>
            </Box>
          </>
        )}

        {(stepInterno === 1 || stepInterno === 2) && renderFormularioEmpresa()}
      </Box>
    </Fade>
  );
};

export default EtapaEmpresa;